var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.931 473.931",
    style: {
      enableBackground: "new 0 0 473.931 473.931"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D62127"
    },
    cx: 236.966,
    cy: 236.966,
    r: 236.966
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC288"
    },
    d: "M110.333,230.433c3.005,3.753,5.257,5.268,6.006,9.018c-6.006,3.012-12.007,15.031-12.007,18.787 c0.737,25.541,24.789,30.81,24.789,30.81s0,0,72.126,0c5.265,0.745,1.5,15.027-1.5,20.28 c-12.767,22.544-20.284,42.824-20.284,53.358c4.501,51.857,39.82,42.817,41.316,37.567c0.752-52.602,12.782-64.62,26.308-73.642 c13.53-9.003,15.034-19.536,30.802-55.603c15.779-36.063,45.092-24.045,45.092-24.045s-0.752-11.266-0.752-117.211 c-88.668-16.539-139.014-14.282-162.299-12.03c-23.307,2.253-30.81,18.028-30.81,26.293c0,9.77-3.008,15.046-6.769,17.283 c-16.531,13.534-11.27,18.035-6.765,27.801c4.513,9.777,3.001,12.782-4.505,19.543C102.21,216.18,107.325,226.691,110.333,230.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C524A"
    },
    d: "M326.76,250.728h45.788c2.503,0,4.531-2.024,4.531-4.539V126.771c0-2.496-2.028-4.543-4.531-4.543 H326.76c-2.503,0-4.531,2.047-4.531,4.543v119.418C322.233,248.704,324.261,250.728,326.76,250.728z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.9cabf768b6e8de59327a67c0b3451dca.svg";
export { ForwardRef as ReactComponent };